import React from 'react';

import Immutable from 'immutable';

import PropTypes from 'prop-types';

import { ButtonToolbar } from 'reactstrap';

import PrintCargoTicketButton from '../../reservation/ticket/ticket-toolbar/PrintCargoTicketButton';

import PrintCargoVoucherButton from '../../reservation/ticket/ticket-toolbar/PrintCargoVoucherButton';

import PayParcelButton from './PayParcelButton';

import {
  CARGO_ITEM_STATUS,
  PARCEL_FINANCIAL_STATUS,
  PARCEL_PAYMENT_STATUS,
  PARCEL_PAYMENT_STATUS_WAITING_FOR_PAYMENT,
  PARCEL_STATUS,
  PARCEL_STATUS_UNCLAIMED,
  PAYMENT_METHOD_PAGO_EN_DESTINO,
  PIN_PAD_TRANSACTION_SOURCE_TYPE,
} from '../../../../config/constants';
import PinPadVoucherButtons from '../../../common/button/PinPadVoucherButtons';

import DeliverParcelButton from './DeliverParcelButton';

import ChangeSecretCodeButton from './ChangeSecretCodeButton';

import CreateCreditNoteParcelButton from './CreateCreditNoteParcelButton';

import SendEmailButton from './SendEmailButton';

import DeliverParcelQrButton from './DeliverParcelQrButton';

import VoidButton from './VoidButton';

import VoidPaymentButton from './VoidPaymentButton';

import DeliverParcelButtonLegalAbandonment from './DeliverParcelButtonLegalAbandonment';

import ChangeConsigneeCustomerButton from './ChangeConsigneeCustomerButton';

import RefundButton from './RefundButton';

import PrintCargoCreditNoteButton from './PrintCargoCreditNoteButton';

import EditParcelAccountingDataButton from './EditParcelAccountingDataButton';
import PrintCargoDebitNoteButton from './PrintCargoDebitNoteButton';

const ParcelToolbar = ({ currentSalesSession, parcel }) => {
  // eslint-disable-next-line no-nested-ternary
  const cargoItems = Array.isArray(parcel.cargoItemList)
    ? parcel.cargoItemList
    : [];

  const hasCreditNote =
    Array.isArray(parcel.creditNoteList) && parcel.creditNoteList.length > 0;

  const hasDebitNote =
    Array.isArray(parcel.debitNoteList) && parcel.debitNoteList.length > 0;

  const hasItemInLegalAbandonment = cargoItems.some(
    (item) => item.status === PARCEL_STATUS_UNCLAIMED,
  );

  const hasItemDelivered = cargoItems.some(
    (item) => item.status === CARGO_ITEM_STATUS.DELIVERED.value,
  );

  return (
    <ButtonToolbar className="pull-right">
      {parcel.financialStatus === PARCEL_FINANCIAL_STATUS.ACTIVE.value && (
        <div>
          <RefundButton parcel={parcel} status={parcel.status} />{' '}
          {hasCreditNote && (
            <>
              <PrintCargoCreditNoteButton parcel={parcel} />{' '}
            </>
          )}
          {hasDebitNote && (
            <>
              <PrintCargoDebitNoteButton parcel={parcel} />{' '}
            </>
          )}
          <PrintCargoTicketButton ticket={parcel} />{' '}
          <PrintCargoVoucherButton voucher={parcel} />{' '}
          {!currentSalesSession.isEmpty() &&
            parcel.salesSessionId === currentSalesSession.get('id') && (
              <>
                <VoidButton parcelId={parcel.id} status={parcel.status} />
              </>
            )}{' '}
          {parcel.isPaymentOnArrival &&
            !currentSalesSession.isEmpty() &&
            parcel.paymentStatus === PARCEL_PAYMENT_STATUS.PAID.value &&
            !hasItemDelivered && (
              <VoidPaymentButton parcelId={parcel.id} />
            )}{' '}
          {parcel.paymentStatus === PARCEL_PAYMENT_STATUS_WAITING_FOR_PAYMENT &&
            parcel.transactionCode === PAYMENT_METHOD_PAGO_EN_DESTINO && (
              <PayParcelButton parcel={parcel} />
            )}{' '}
          {(parcel.paymentStatus !==
            PARCEL_PAYMENT_STATUS_WAITING_FOR_PAYMENT ||
            parcel.transactionCode !== PAYMENT_METHOD_PAGO_EN_DESTINO) &&
            parcel.status !== PARCEL_STATUS.DELIVERED.value && (
              <>
                {!hasItemInLegalAbandonment && (
                  <>
                    <DeliverParcelButton parcel={parcel} />{' '}
                    <DeliverParcelQrButton parcel={parcel} />{' '}
                  </>
                )}

                {hasItemInLegalAbandonment && (
                  <DeliverParcelButtonLegalAbandonment parcel={parcel} />
                )}
              </>
            )}{' '}
          {parcel.status !== PARCEL_STATUS.DELIVERED.value && (
            <ChangeSecretCodeButton parcel={parcel} />
          )}{' '}
          <CreateCreditNoteParcelButton parcel={parcel} />{' '}
          <ChangeConsigneeCustomerButton parcel={parcel} />{' '}
          <SendEmailButton parcel={parcel} />{' '}
          <EditParcelAccountingDataButton parcel={parcel} />
        </div>
      )}
      <div className="ml-1">
        <PinPadVoucherButtons
          sourceType={PIN_PAD_TRANSACTION_SOURCE_TYPE.PARCEL}
          sourceId={parcel.id}
        />
      </div>
    </ButtonToolbar>
  );
};

ParcelToolbar.propTypes = {
  parcel: PropTypes.instanceOf(Object).isRequired,
  currentSalesSession: PropTypes.instanceOf(Immutable.Map).isRequired,
};

export default ParcelToolbar;
